import { useTranslation } from "@equiem/web-ng-lib";
import { PageTitle } from "@equiem/web-ng-lib";
import { NextPage } from "next";
import React from "react";
import { GeneralLayout } from "../components/layout/GeneralLayout";
import { LegalContent } from "../components/legal/LegalContent";
import { withAppContexts } from "../contexts/withAppContexts";
import { PageViewPageType } from "../generated/gateway-client";

export const TermsPage: NextPage = ({}) => {
  const { t } = useTranslation();

  return (
    <GeneralLayout>
      <h1 className="text-site">{t("main.termsAndConditions")}</h1>
      <PageTitle>{t("main.termsAndConditions")}</PageTitle>
      <LegalContent type="terms" />
    </GeneralLayout>
  );
};

export default withAppContexts(TermsPage, {
  requireAuth: false,
  skipMetrics: false,
  skipLegalCheck: true,
  pageViewType: PageViewPageType.Static,
  pageTitle: "Terms & Conditions",
});
